import { takeEvery } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { fetchApiAuth } from '../utils/api';

import {
    productsSuccess,
    productsFailure
} from './productsActions';

const {
    PRODUCTS_REQUEST
} = require('./productsActions').constants;

function* fetchResources() {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'get',
            url: 'products'
        });

        yield put(productsSuccess(response));
    } catch (e) {
        console.log('res', e.response);
        yield put(productsFailure(e.response && e.response.data ? e.response.data.message : e));
    }
}

/**
 * Watch actions
 */
export default function* productsSaga() {
    yield* [
        takeEvery(PRODUCTS_REQUEST, fetchResources)
    ];
}



/** WEBPACK FOOTER **
 ** ./src/core/products/productsSaga.js
 **/